import { PayloadAction } from '@reduxjs/toolkit';

const updateProperty =
  <S, P extends keyof S>(prop: P, formatter?: (value: S[P]) => S[P]) =>
  (state: S, action: PayloadAction<S[P]>) => {
    state[prop] = formatter ? formatter(action.payload) : action.payload;
  };

export default updateProperty;
